import Utils from "../utils"

class ContainerImportAPI
{
  static parse(filename, cb)
  {
    Utils.post('parse_container_import', {filename}, (err, res) => {
      if (err) return cb(err)
      cb(null, res.data)
    })
  }

  static commit(filename, rows, unmatched, cb)
  {
    Utils.post('commit_container_import', {filename, rows, unmatched}, (err, res) => {
      if (err) return cb(err)
      cb(null, res.data)
    })
  }

  static undo(id, cb)
  {
    Utils.post(`undo_container_import/${id}`, {}, (err, res) => {
      if (err) return cb(err)
      cb(null, res.data)
    })
  }

  static history(cb)
  {
    Utils.get('container_imports', (err, res) => {
      if (err) return cb(err)
      cb(null, res.data)
    })
  }

  static historyRows(id, cb)
  {
    Utils.get(`container_imports/${id}`, (err, res) => {
      if (err) return cb(err)
      cb(null, res.data)
    })
  }

  static lookup(po, style, cb)
  {
    const qs = `po=${encodeURIComponent(po || '')}&style=${encodeURIComponent(style || '')}`
    Utils.get(`container_import_lookup?${qs}`, (err, res) => {
      if (err) return cb(err)
      cb(null, res.data)
    })
  }

  static setPending(vpoId, lineIndex, value, cb)
  {
    Utils.post('container_import_set_pending', {vpoId, lineIndex, value}, (err, res) => {
      if (err) return cb(err)
      cb(null, res.data)
    })
  }
}

export default ContainerImportAPI
